import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { createSearch } from '../../services/intelligenceApi';

function IntelligenceSearch() {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    const trimmed = query.trim();
    if (!trimmed) return;
    setSubmitting(true);
    setError('');
    try {
      const res = await createSearch(trimmed, true);
      navigate(`/intelligence/search/${res.data.query_id}`);
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Search failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="main-body">
      <div className="intel-hero">
        <h1 className="page-title">Intelligence</h1>
        <p className="intel-hero-lead">
          Paste any indicator — IP, domain, email, wallet, panel URL — and run in-house enrichment.
        </p>
        <form className="intel-search-form" onSubmit={handleSubmit}>
          <input
            className="form-input intel-search-input"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Paste indicator, URL, email, wallet..."
          />
          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? 'Starting...' : 'Search'}
          </button>
        </form>
        {error && <div className="hdp-alert error" style={{ marginTop: '12px' }}>{error}</div>}
      </div>

      <div className="intel-quick-tools">
        <button type="button" className="intel-tool-card" onClick={() => navigate('/intelligence/extractor')}>
          <span>🧩</span>
          <strong>Extractor</strong>
          <span>Pull IOCs from text</span>
        </button>
        <button type="button" className="intel-tool-card" onClick={() => navigate('/intelligence/compare')}>
          <span>⚖️</span>
          <strong>Compare</strong>
          <span>Side-by-side analysis</span>
        </button>
        <button type="button" className="intel-tool-card" onClick={() => navigate('/intelligence/panel-hunter')}>
          <span>🎯</span>
          <strong>Panel Hunter</strong>
          <span>Scam panel fingerprints</span>
        </button>
        <button type="button" className="intel-tool-card" onClick={() => navigate('/intelligence/corpus')}>
          <span>📚</span>
          <strong>Corpus</strong>
          <span>Internal doc search</span>
        </button>
        <button type="button" className="intel-tool-card" onClick={() => navigate('/intelligence/history')}>
          <span>🕘</span>
          <strong>History</strong>
          <span>Past enrichments</span>
        </button>
      </div>
    </div>
  );
}

export default IntelligenceSearch;
